const BUSINESS = {
  firstPurchase: {
    tooltip: {
      title: 'Pedidos de primeira compra',
      body: 'Entregar rápido e gelado é essencial para o cliente ter uma boa experiência e retornar a fazer pedidos',
    },
    tag: 'Prioridade',
  },
  priorityPurchase: {
    tooltip: {
      title: 'Pedidos prioritários',
      bodyBreak: 'Dê uma atenção especial e <br /> entregue  no menor tempo.',
      body: 'Dê uma atenção especial e entregue no menor tempo possível.',
    },
    tag: 'Prioridade',
  },
  automaticPrint: {
    option: 'Impressão Automática',
    tooltip: {
      info: 'Ative para imprimir automaticamente as notas dos pedidos aceitos.',
      screenInfo:
        'A impressão só acontece enquanto estiver na tela de Pedidos Pendentes.',
      reminder:
        'Lembre-se de configurar o navegador para que a impressão ocorra sem intervenção.',
      help: 'Peça ajuda ao supervisor do Zé.',
      additionalInfo:
        'Se não configurar o navegador, a automação funcionará, mas a janela de impressão será exibida.',
    },
  },
  icon: 'ícone',
}

export default BUSINESS
